var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransitionWrapper',_vm._g({class:['bubble-box', ("is-color-" + _vm.color)],scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_vm._t("default",null,null,slotProps)]}}],null,true)},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }